export interface ShiftTypeChoice {
  id: string;
  status: "ACTIVE" | "INACTIVE";
}

export function resolveManualShiftTypeId(
  existingShiftTypeId: string | undefined,
  types: ShiftTypeChoice[],
): string {
  const activeTypes = types.filter((type) => type.status === "ACTIVE");
  if (
    existingShiftTypeId &&
    activeTypes.some((type) => type.id === existingShiftTypeId)
  ) {
    return existingShiftTypeId;
  }
  return activeTypes[0]?.id ?? "";
}

export function manualShiftEntryProblem(
  canManage: boolean,
  activeTypeCount: number,
): string | null {
  if (!canManage) {
    return "Smjene možete pregledavati, ali ovaj račun nema ovlast za njihov upis ili izmjenu.";
  }
  if (activeTypeCount === 0) {
    return "Nema aktivne vrste smjene. U Šifrarniku smjena aktivirajte postojeću ili dodajte novu vrstu.";
  }
  return null;
}
